"use client";

import { useI18n, type Locale } from "@/lib/i18n/I18nProvider";
import { splitLocale } from "@/lib/i18n/config";
import { track, EVENTS } from "@/lib/analytics";

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();

  /**
   * На локализованных публичных путях (`/en` `/ru`) меняем язык через смену URL —
   * полная навигация даёт корректный SSR-рендер и канонический URL новой локали.
   * В кабинете (без префикса локали) — прежнее поведение (клиентский setLocale).
   */
  function choose(next: Locale) {
    if (next !== locale) {
      track(EVENTS.languageSwitch, { from: locale, to: next });
    }
    setLocale(next);
    if (typeof window !== "undefined") {
      const { locale: prefix, rest } = splitLocale(window.location.pathname);
      if (prefix) {
        const target = `/${next}${rest === "/" ? "" : rest}${window.location.search}`;
        window.location.assign(target);
      }
    }
  }

  return (
    <div
      className="flex items-center rounded-lg border border-keiro-green/20 bg-keiro-gray-100/80 p-0.5 text-caption font-medium"
      role="group"
      aria-label={t("topBar.language")}
    >
      <button
        type="button"
        onClick={() => choose("ru")}
        className={`rounded-lg px-2 py-1 transition ${
          locale === "ru"
            ? "bg-white text-keiro-green-dark shadow-sm"
            : "text-keiro-gray-600 hover:text-keiro-obsidian"
        }`}
        aria-pressed={locale === "ru"}
      >
        RU
      </button>
      <button
        type="button"
        onClick={() => choose("en")}
        className={`rounded-lg px-2 py-1 transition ${
          locale === "en"
            ? "bg-white text-keiro-green-dark shadow-sm"
            : "text-keiro-gray-600 hover:text-keiro-obsidian"
        }`}
        aria-pressed={locale === "en"}
      >
        EN
      </button>
    </div>
  );
}
